import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBuildingColumns, faCalculator,faCreditCard,faLockOpen,faUser } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { msgAccessPromt } from "../../constant/constant";
import { update_bank_details } from "../../features/userSlice";
import {  faGooglePay } from "@fortawesome/free-brands-svg-icons";
import { useNavigate } from "react-router-dom";
import { useT } from "../../i18n";

const AddBankDetails = () => {
  
const {Info}=useSelector((state)=>state.users);
const dispatch=useDispatch();
const navigate=useNavigate();
const { t } = useT();
const [bankData,setbankData]=useState({
    ifscCode:Info?.bank_details?.ifsc_code,
    ac_num:Info?.bank_details?.account_number,
    bank_name:Info?.bank_details?.bank_name,
    ac_holder_name:Info?.bank_details?.account_holder_name,
    paytm:Info?.paytm,
    gpay:Info?.googlepay,
    phonepay:Info?.phonepay,
});

const handleSubmit = async(e) => {

        msgAccessPromt({dispatch,msg:'LOADING',error:true});
     
        e.preventDefault();
        let dataSet = new FormData();

       
        
        dataSet.append('ifsc_code',bankData.ifscCode);
        dataSet.append('phone_number',Info?.phone_number);
        dataSet.append('account_number',bankData?.ac_num);
        dataSet.append('bank_name',bankData?.bank_name);
        dataSet.append('account_holder_name', bankData?.ac_holder_name);
        if(bankData.paytm){dataSet.append('paytm', bankData?.paytm);}
        if(bankData.phonepay){dataSet.append('phonepay', bankData?.phonepay);}
        if(bankData.gpay){dataSet.append('googlepay', bankData?.gpay);}
        
        

        try {
            const data = await dispatch(update_bank_details(dataSet)).unwrap(); // Unwrap to get the resolved value
            if(data.success){
                msgAccessPromt({dispatch,error:false,msg:data.msg});
                navigate('/home');
            }else{
                msgAccessPromt({dispatch,error:true,msg:data.msg});
            }
        } catch (error) {
            console.error('API Error:', error);
            msgAccessPromt({dispatch,error:true,msg:'Api Error'});

        }
        
    };

return (
        <div className="af-screen">
            
            <h2 className="af-title">{t("Bank Details")}</h2>
            <div className="input-group">
                <i><FontAwesomeIcon icon={faLockOpen} /></i>
                <input className="input_lable_deep" type="text" value={bankData.ifscCode} onChange={(e)=>setbankData({...bankData,ifscCode:e.target.value.toUpperCase()})} placeholder={t("IFSC Code")} />
            </div>
            <div className="input-group">
                <i><FontAwesomeIcon icon={faCalculator} /></i>
                <input className="input_lable_deep" type="number" value={bankData.ac_num} onChange={(e)=>setbankData({...bankData,ac_num:e.target.value})} placeholder={t("Account number")} />
            </div>
            <div className="input-group">
                <i><FontAwesomeIcon icon={faBuildingColumns} /></i>
                <input className="input_lable_deep" type="text" value={bankData.bank_name} onChange={(e)=>setbankData({...bankData,bank_name:e.target.value})} placeholder={t("Bank name")} />
            </div>
            <div className="input-group">
                <i><FontAwesomeIcon icon={faUser} /></i>
                <input className="input_lable_deep" type="text" value={bankData.ac_holder_name} onChange={(e)=>setbankData({...bankData,ac_holder_name:e.target.value})} placeholder={t("Account holder name")} />
            </div>

            <div className="input-group">
                <i><FontAwesomeIcon icon={faGooglePay} /></i>
                <input className="input_lable_deep" type="number" value={bankData.gpay} onChange={(e)=>setbankData({...bankData,gpay:e.target.value})} placeholder={t("Google Pay number")} />
            </div>
            <div className="input-group">
                <i><FontAwesomeIcon icon={faCreditCard} /></i>
                <input className="input_lable_deep" type="number" value={bankData.phonepay} onChange={(e)=>setbankData({...bankData,phonepay:e.target.value})} placeholder={t("PhonePe number")} />
            </div>
            <div className="input-group">
                <i><FontAwesomeIcon icon={faCreditCard} /></i>
                <input className="input_lable_deep" type="number" value={bankData.paytm} onChange={(e)=>setbankData({...bankData,paytm:e.target.value})} placeholder={t("Paytm number")} />
            </div>
            <button onClick={handleSubmit} className="continue-button">{t("Submit")}</button>
        </div>
    );
};

export default AddBankDetails;
